import { apiClient } from './apiClient';

export type SurveyDispatchReportItem = {
  id: string;
  companyId?: string | null;
  companyName?: string | null;
  serviceTicketId?: string | null;
  ticketCode?: string | null;
  recipientEmail?: string | null;
  contactName?: string | null;
  status: string;
  sentAtUtc: string;
  respondedAtUtc?: string | null;
  score?: number | null;
  comment?: string | null;
};

export type SurveyDispatchReportResult = {
  items: SurveyDispatchReportItem[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type SurveyDispatchType = 'Csat' | 'Nps';

export async function listSurveyDispatches(params: {
  surveyType: SurveyDispatchType;
  companyId?: string;
  fromUtc?: string;
  toUtc?: string;
  page?: number;
  pageSize?: number;
}): Promise<SurveyDispatchReportResult> {
  const response = await apiClient.get<SurveyDispatchReportResult>(
    '/v1/customer-success/survey-dispatches',
    {
      params: {
        surveyType: params.surveyType,
        companyId: params.companyId || undefined,
        fromUtc: params.fromUtc || undefined,
        toUtc: params.toUtc || undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 25,
      },
    },
  );
  return response.data;
}
